import {
  collection,
  doc,
  getFirestore,
  serverTimestamp,
  setDoc,
} from "firebase/firestore"

/**
 * Firestore document structure for uploaded files:
 * - userId:              ID of the user who uploaded the document
 * - fileName:            Original name of the uploaded file
 * - uniqueFileName:      Unique name used for storing the file in Firebase Storage
 * - storageUrl:          Public download URL for the uploaded file
 * - extension:           File extension (e.g., 'pdf', 'docx')
 * - size:                File size in bytes
 * - status:              Processing status (e.g., 'pending', 'ready', 'error')
 * - errorMessage:        Error message if processing fails
 * - summary:             Short summary of the document content (AI-generated)
 */

const saveFileMetaToFirestore = async (props) => {
  const db = getFirestore()

  const {
    userId,
    fileName,
    uniqueFileName,
    storageUrl,
    extension,
    size,

    status = "pending",
    errorMessage = null,

  } = props

  // Create a doc ref first so we can store _id like in mobile
  const ref = doc(collection(db, "documents"))
  const payload = {
    _id: ref.id,
    _createdAt: serverTimestamp(),
    _updatedAt: serverTimestamp(),
    _createdBy: userId,
    userId,
    fileName,
    uniqueFileName,
    storageUrl,
    extension,
    size,
    status,
    errorMessage,
    // Parity fields used in mobile flows
    analysis: null,
    chunksCount: 0,
    language: [],
    progress: 0,
    step: null,
    understoodSections: [],
    unclearSections: [],
    reviewProgress: 0,
  }

  await setDoc(ref, payload)
  return ref
}

export default saveFileMetaToFirestore
